import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent {
    @Input() checkedLabel?: string;
    @Input() uncheckedLabel?: string;
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() checked = false;
    @Input() disabled = false;

    @Output() onChange = new EventEmitter<boolean>();

    handleChange(isChecked: boolean): void {
        this.checked = isChecked;

        this.onChange.emit(isChecked);
    }
}
